import type { TPageLoadAction } from 'core/product/PageLoadActionProcessor';
import { PAGE_LOAD_ACTION_TYPES } from 'core/product/PageLoadActionProcessor';

/**
 * @description Base SignInToBuyModalMixin implementation
 * @param DrawerDialog Base widget for extending
 * @returns SignInToBuyModalMixin class
 */
function SignInToBuyModalMixinClassCreator(DrawerDialog: import('core/global/drawerDialog').TDrawerDialog) {
    class SignInToBuyModalMixin extends DrawerDialog {
        pageLoadAction?: TPageLoadAction;

        init() {
            super.init();

            this.eventBus().on('signInToBuyModal.show', 'showSignInToBuyModal');
        }

        /**
         * @description Show modal dialog with sign in to buy content
         * @param templateData Data for rendering modal
         * @param cb Callback function to execute after modal is shown
         */
        showSignInToBuyModal(templateData?: Record<string, unknown>, cb?: () => void): Promise<void> {
            this.pageLoadAction = <TPageLoadAction>templateData?.pageLoadAction;

            return this.showModal(templateData, cb);
        }

        /**
         * @description Handles sign in to buy form submit
         */
        handleSignInToBuyFormSubmit() {
            this.eventBus().emit('addPageLoadAction', this.pageLoadAction);
        }

        /**
         * @description Handles sign in to buy form submit
         */
        handleGTMUpdates(widget, eventName, eventData) {
            if (
                this.pageLoadAction &&
                (this.pageLoadAction.type === PAGE_LOAD_ACTION_TYPES.AVAILABILITY_REMINDER ||
                    this.pageLoadAction.type === PAGE_LOAD_ACTION_TYPES.STORE_AVAILABILITY)
            ) {
                eventData.location = 'registration_wall';
            }

            this.eventBus().emit(eventName, eventData);
        }
    }

    return SignInToBuyModalMixin;
}

export type TSignInToBuyModalMixin = ReturnType<typeof SignInToBuyModalMixinClassCreator>;

export type TSignInToBuyModalMixinInstance = InstanceType<TSignInToBuyModalMixin>;

export default SignInToBuyModalMixinClassCreator;
